import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import TaskTitle from 'components/onboarding/TaskTitle';
import { HELP_ARTICLE_HOME } from 'components/onboarding/constants';
import * as Types from 'components/onboarding/typings';

interface Props {
  task: Types.Task;
  isOnHomePage?: boolean;
}

function TaskSummary({ task, isOnHomePage }: Props) {
  const classes = useStyles();

  const { helpArticleLink: _helpArticleLink, shortDescription } = task;

  const helpArticleLink = _helpArticleLink || HELP_ARTICLE_HOME;

  return (
    <div className={classes.root}>
      <TaskTitle task={task} isOnHomePage={isOnHomePage} />
      {isOnHomePage ? (
        <div className={classes.shortTextContainer}>
          <Typography variant="caption" className={classes.shortText}>
            {shortDescription}
          </Typography>
        </div>
      ) : (
        <Typography variant="caption" className={classes.doc}>
          View{' '}
          <Link
            href={helpArticleLink}
            color="inherit"
            underline="always"
            target="_blank"
            rel="noopener noreferrer"
          >
            documentation
          </Link>
        </Typography>
      )}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  shortTextContainer: {
    marginLeft: theme.spacing(5.5),
    maxWidth: 700,
  },
  shortText: {
    // @ts-ignore
    color: theme.colors.gray2,
  },
  doc: {
    marginLeft: theme.spacing(5),
    // @ts-ignore
    color: theme.colors.gray2,
  },
}));

export default TaskSummary;
